<template>
	<div class="tomato-chat-page">
		<div @click="toClose()" v-if="userType==3" style="
			position: absolute; 
			top:30px; 
			right: 30px; 
			cursor: pointer;
			z-index: 99;
		">
			<img src="@/ico/stutas/close.svg" style="width:28px;" alt="退出">
		</div>

		<div v-if="isLogin">
			<Chat class="content-box" ref="chat" v-show="activeTab === 'chat'" :courseClassId="courseClassId"
				:studentId="studentId" :style="{ height: contentHeight + 'px' }" />
			<UploadImage class="content-box" v-show="activeTab === 'upload'" :courseClassId="courseClassId"
				:style="{ height: contentHeight + 'px' }" />
			<WorksShow class="content-box" ref="worksShow" v-show="activeTab === 'workshow'"
				:courseClassId="courseClassId" :studentId="studentId" :style="{ height: contentHeight + 'px' }" />
			<Experiment class="content-box" v-show="activeTab === 'experiment'" :courseClassId="courseClassId"
				:style="{ height: contentHeight + 'px' }" />
			<Classworkshow class="content-box" ref="classworkshow" v-show="activeTab === 'classworkshow'"
				:courseClassId="courseClassId" :studentId="studentId" :style="{ height: contentHeight + 'px' }" />
			<HtmlPlayView class="content-box" ref="htmlfile" v-show="activeTab === 'htmlfile'" :htmlName="htmlName"
				:url="srcUrl" :htmlId="htmlId" :courseClassId="courseClassId" :key="dialogKey"
				:iframeUrlOrigin="iframeUrlOrigin" :iframeUrlPlay="iframeUrlPlay" :isplayF="isplayF"
				:studentId="studentId" :style="{ height: contentHeight + 'px' }" />
		</div>

		<div class="bottom-nav">
			<!-- AI 助手 -->
			<div class="nav-item" v-if="forRole(item)"
				:class="{ active: activeTab === item.key, disabled: isMenuDisabled(item.key) }"
				@click="!isMenuDisabled(item.key) && switchTab(item.key)" v-for="(item, index) in parms.bottomMenu"
				:key="index">
				<!-- 选中图标 -->
				<img class="icon-on" :src="getIconUrl(item,'iconOn')" />
				<!-- 未选中图标 -->
				<img class="icon-off" :src="getIconUrl(item,'iconOff')" />
				<!-- 菜单名称 -->
				<span class="nav-text">{{ item.name }}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import Chat from "./components/chat.vue";
	import UploadImage from "./components/UploadImage.vue";
	import WorksShow from "./components/WorksShow.vue";
	import Experiment from "./components/Experiment.vue";
	import Classworkshow from "./components/Classworkshow.vue";
	import HtmlPlayView from '../../../views/components/html/HtmlIframeView.vue'
	import {
		bottomMenu
	} from "@/js/calssComponets.js"
	export default {
		name: "TomatoChatPage",
		components: {
			Chat,
			UploadImage,
			WorksShow,
			Experiment,
			Classworkshow,
			HtmlPlayView
		},
		props: {
			studentId: {
				type: String,
				default: ""
			},
			disabledMenus: {
				type: String,
				default: ""
			},
			isSave: {
				type: Boolean,
				default: false
			},
		},

		data() {
			return {
				activeTab: "",
				courseClassId: localStorage.getItem('courseClassId'),
				userType: localStorage.getItem('userType') || "",
				contentHeight: 0, // 动态高度
				parms: {},
				bottomMenu: [],
				allTabs: [],
				isLogin: false,
				login: null,
				iframeUrlOrigin: '',
				iframeUrlPlay: '',
				isplayF: 0,
				dialogKey: 1,
				srcUrl: '',
				htmlId: 0,
				htmlName: "",

			};
		},
		watch: {
			disabledMenus: {
				handler(newVal) {
					this.autoSwitchToValidTab();
				},
				immediate: true
			}
		},
		created() {
			if (localStorage.getItem('userType') == 2) {
				this.isplayF = 1
				
			} else {
				this.isplayF = 2
			}

			this.foinfo()
			this.forBottomMenu()

			this.calcHeight();
			window.addEventListener('resize', this.calcHeight);
	
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.calcHeight);
			if (this.iframeUrlOrigin) URL.revokeObjectURL(this.iframeUrlOrigin);
			if (this.iframeUrlPlay) URL.revokeObjectURL(this.iframeUrlPlay);
		},

		methods: {
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text: text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close()
				}
			},
			forRole(val) {
				console.log(val)
				if (this.userType == '3' && val.stu) {
					return true
				}
				if (this.userType == '2' && val.tea && localStorage.getItem('isSave') == "false") {
					return true
				}
				if (this.userType == '2' && val.audience && localStorage.getItem('isSave')) {
					return true
				}
				return false
			},
			forBottomMenu() {
				this.allTabs = []
				this.bottomMenu = bottomMenu()
				for (let i = 0; i < this.bottomMenu.length; i++) {
					this.allTabs.push(this.bottomMenu[i].key)
				}

				this.activeTab = this.allTabs[0]

				//switchTab
			},
			getIconUrl(url, type) {
				if (!url[type]) return '';
				if (url[type].startsWith('@/ico/')) {
					return this.bottomMenu.filter(v => v.key == url.key)[0][type] || ''
				}
				return url[type] || '';
			},
			//初始化属性
			async foinfo() {
				this.loginOpen('初始化中...')
				const preloadImage = async (url) => {
					if (!url || !url.startsWith('http')) return url;
					return new Promise((resolve) => {
						const img = new Image();
						img.onload = () => resolve(url);
						img.onerror = () => resolve(url);
						img.src = url;
					});
				};

				// 通用递归处理函数
				const processConfig = async (obj) => {
					if (!obj) return obj;
					if (Array.isArray(obj)) {
						return await Promise.all(obj.map(item => processConfig(item)));
					}
					if (typeof obj === "object" && obj !== null) {
						const newObj = {};
						for (let key in obj) {
							const val = obj[key];
							if (typeof val === "string" && val.startsWith("https:")) {
								const signed = await this.$oss.getUrl(val);
								await preloadImage(signed);
								newObj[key] = signed;
							} else {
								newObj[key] = await processConfig(val);
							}
						}
						return newObj;
					}
					return obj;
				};

				try {
					let res = await this.API.get(this.API.admin.getCourseConfig + localStorage.getItem('courseId'));
					if (res.data.data) {
						let parms = JSON.parse(res.data.data);

						// 处理所有配置：包括 bottomMenu、chat、upload、experiment 等
						if (parms.bottomMenu) {
							parms.bottomMenu = await Promise.all(parms.bottomMenu.map(async (v) => {
								if (v.iconOff.startsWith("https:")) {
									v.iconOff = await this.$oss.getUrl(v.iconOff);
									await preloadImage(v.iconOff);
								}
								if (v.iconOn.startsWith("https:")) {
									v.iconOn = await this.$oss.getUrl(v.iconOn);
									await preloadImage(v.iconOn);
								}
								return {
									...v
								};
							}));
						}

						// 用递归处理 chat、upload、experiment 等对象
						if (parms.chat) parms.chat = await processConfig(parms.chat);
						if (parms.upload) parms.upload = await processConfig(parms.upload);
						if (parms.experiment) parms.experiment = await processConfig(parms.experiment);

						this.parms = parms;
						console.log('parms', parms)
						if (parms?.bottomMenu?.filter(v => v.stu == true)?.length > 0) {
							if (this.userType == 3) {
								var stu = parms.bottomMenu.filter(v => v.stu == true)[0]?.key || ''
								if (stu) {
									this.switchTab(stu)
								}
							}
							if (this.userType == 2) {
								//暂时无法判断老师还是观课
								if (!this.isSave) {
									var tea = parms.bottomMenu.filter(v => v.tea == true)[0]?.key || ''
									if (tea) {
										console.log('eeee',localStorage.getItem("AiCourClassTab"))
										if(localStorage.getItem("AiCourClassTab")){
											
											this.switchTab(localStorage.getItem("AiCourClassTab"))
										}else{
											this.switchTab(tea)
										}
										
									}
								}
								if (this.isSave) {
									var audience = parms.bottomMenu.filter(v => v.audience == true)[0]?.key || ''
									if (audience) {
										this.switchTab(audience)
									}
								}

							}

						}
						// console.log('this.parms ',this.parms)
						localStorage.setItem('parms', JSON.stringify(parms));
						this.isLogin = true
						this.noLogin()
					}
				} catch (error) {
					console.error('获取配置失败', error);
					localStorage.removeItem('parms');
					this.noLogin()
				}
			},
			// 核心：实时计算高度
			calcHeight() {
				this.contentHeight = window.innerHeight - 80;
			},

			// 判断菜单是否禁用
			isMenuDisabled(tabName) {
				if (!this.disabledMenus) return false;
				let arr = this.disabledMenus.split(",");
				return arr.includes(tabName);
			},

			autoSwitchToValidTab() {
				if (!localStorage.getItem('userType')) return;
				if (localStorage.getItem('userType') != 3) return;

				const currentDisabled = this.isMenuDisabled(this.activeTab);
				if (!currentDisabled) return;
				for (let tab of this.allTabs) {
					if (!this.isMenuDisabled(tab)) {
						this.switchTab(tab);
						break;
					}
				}
			},

			forStudent() {
				if (this.activeTab == 'chat') {
					this.$refs.chat.loadHistoryChat()
				}
				if (this.activeTab == "workshow") {
					this.$refs.worksShow.getCallbackList()
				}
			},
			forChat(arr) {
				if (this.$refs.chat) {
					this.$refs.chat.toTeacherMsg(arr)
				}
			},
			toClose() {
				this.$emit("toSet");
			},

			async switchTab(tab) {
				if(this.userType==2&&!this.isSave&&tab){
					localStorage.setItem('AiCourClassTab',tab)
				}
				if (!tab) tab = "chat";
				if (this.isMenuDisabled(tab)) return;
				
				if (tab == "htmlfile") {
					//当不存在网页文件的blod的时候加载一次,保证学生切换菜单不销毁
					if (!this.iframeUrlPlay) {
						this.htmlName = ''
						if (this.parms.htmlFile?.htmlList[0]?.src) {
							this.srcUrl = await this.getDetail(this.parms.htmlFile.htmlList[0])
							this.htmlName = this.parms.htmlFile.htmlList[0].typeName
							this.loadOssHtml(this.srcUrl)
						} else {
							this.$message.success('网页文件异常')
						}
					}
					this.activeTab = tab;
				} else {
					this.activeTab = tab;
				}
				// this.activeTab = tab;
			},
			async getDetail(item) {
				try {
					const res = await this.API.get(this.API.fileurl.getDetail + "?id=" + item.id)

					if (res?.data) {
						this.htmlId = res.data.id || 0
					}
					return res.data.url

				} catch (err) {
					item.src
				}
			},
			async loadOssHtml(src) {
				let oss = await this.$oss.getDownloadUrl(src)
				console.log('oss', oss)
				try {
					// 批量释放全部旧blob，防止浏览器回收空白页面
					const releaseBlob = (url) => {
						if (url && url.startsWith('blob:')) URL.revokeObjectURL(url);
					}
					releaseBlob(this.iframeSrc);
					releaseBlob(this.iframeUrlOrigin);
					releaseBlob(this.iframeUrlPlay);
					releaseBlob(this.cachePlaySnapshot);

					const blobUrl = await this.loadOssHtmlBlob(oss)
					this.iframeSrc = URL.createObjectURL(blobUrl);
					this.iframeUrlOrigin = URL.createObjectURL(blobUrl);
					this.iframeUrlPlay = URL.createObjectURL(blobUrl);
					this.$message.success('网页智能体加载完成')
				} catch (err) {
					this.$message.error('读取OSS失败：' + err.message)
					console.error(err)
				}
			},
			async loadOssHtmlBlob(ossUrl) {
				try {
					const res = await fetch(ossUrl, {
						method: "GET",
						mode: "cors"
					});
					if (!res.ok) {
						throw new Error(`OSS请求失败，状态码：${res.status}，链接过期/无跨域权限`);
					}
					const rawBlob = await res.blob();
					const htmlBlob = new Blob([rawBlob], {
						type: "text/html;charset=utf-8"
					});
					// const blobUrl = 
					return htmlBlob;
				} catch (err) {
					this.$message.error('读取OSS失败：' + err.message);
					console.error(err);
					return ''
				}
			},
		}
	};
</script>

<style scoped>
	.tomato-chat-page {
		width: 100%;
		margin: 0 auto;
		height: 100vh;
		background-color: #fff9e6;
		display: flex;
		flex-direction: column;
		font-family: "PingFang SC", "Helvetica Neue", sans-serif;
		overflow: hidden;
	}

	.content-box {
		/* 去掉原来的 calc，由 JS 控制 */
		flex-shrink: 0;
	}

	.bottom-nav {
		height: 80px;
		display: flex;
		justify-content: space-around;
		background-color: #ffffff;
		border-top: 1px solid #c5e1a5;
		align-items: center;
		flex-shrink: 0;
	}

	.nav-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #666;
		font-size: 12px;
		cursor: pointer;
	}

	.nav-item.active {
		color: #2196f3;
	}

	.nav-item .icon-on {
		display: none;
		width: 24px;
		height: 24px;
		margin-bottom: 4px;
		object-fit: contain;
	}

	.nav-item .icon-off {
		display: block;
		width: 24px;
		height: 24px;
		margin-bottom: 4px;
		object-fit: contain;
	}

	.nav-item.active .icon-on {
		display: block;
	}

	.nav-item.active .icon-off {
		display: none;
	}

	.nav-item.disabled {
		opacity: 0.4;
		pointer-events: none;
	}
</style>